import * as React from 'react';
import {
    Alert,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';
import { useTranslate } from 'react-admin';
import { useCampaignExportDeliveries } from './useCampaignExportDeliveries';

const CampaignExportHistory = () => {
    const translate = useTranslate();
    const { data: deliveries, error } = useCampaignExportDeliveries();

    if (error) {
        return <Alert severity="error">{translate('resources.campaign.delivery_report.error')}</Alert>;
    }
    if (!deliveries) return <CircularProgress />;
    if (!deliveries.length) {
        return <Alert severity="info">{translate('resources.campaign.delivery_report.empty')}</Alert>;
    }

    return (
        <>
            <Alert severity="info" sx={{ mb: 2 }}>
                {translate('resources.campaign.delivery_report.description')}
            </Alert>
            <Table size="small" aria-label={translate('resources.campaign.tabs.export_history')}>
                <TableHead>
                    <TableRow>
                        <TableCell>{translate('resources.campaign.delivery_report.time')}</TableCell>
                        <TableCell>{translate('resources.campaign.delivery_report.type')}</TableCell>
                        <TableCell>{translate('resources.campaign.delivery_report.status')}</TableCell>
                        <TableCell align="right">{translate('resources.campaign.delivery_report.attempts')}</TableCell>
                        <TableCell>{translate('resources.campaign.delivery_report.error_detail')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {deliveries.map(delivery => (
                        <TableRow key={delivery.guid}>
                            <TableCell>
                                {new Date(delivery.modified || delivery.created).toLocaleString('fi-FI', {
                                    timeZone: 'Europe/Helsinki',
                                })}
                            </TableCell>
                            <TableCell>
                                {translate(`resources.campaign.delivery_report.types.${delivery.delivery_type}`)}
                            </TableCell>
                            <TableCell>
                                {translate(`resources.campaign.delivery_report.statuses.${delivery.status}`)}
                            </TableCell>
                            <TableCell align="right">{delivery.attempts}</TableCell>
                            <TableCell>{delivery.error || '—'}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </>
    );
};

export default CampaignExportHistory;
